export default {
    dialog: {
        msgShow: "Notification",
        buttonOk: 'OK',
        buttonCancel: 'cancel',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Close'
    },
    employeeNumber: "Technician ID",
    pleaseEnterEmployeeNumber: "Enter technician ID",
    password: "Password",
    pleaseEnterPassword: "Enter password",
    login: "Log in",
    required: "Required",
    synchronize: "Sync.",
    salesOrder: "Service report",
    pleaseEnterHome: "Enter customer name & service report",
    searchFilter: "Search & Filter",
    machineSpecifications: "Machine data",
    processingStatus: "State of affairs",
    processing: "In progress",
    finish: "Completed",
    waitCountermeasures: "Wait repair",
    reset: "Return",
    submit: "Sent",
    muMachineInvestigation: "Machinery utilization",
    logout: "Log out",
    searchDate: "Search date",
    time: "Search time",
    basicInformation: "Customer data",
    addSalesOrder: "Add service report",
    save: "Save",
    date: "Date",
    pleaseSelectDate: "Date select",
    travelNumber: "Service report file",
    pleaseEnterTravelNumber: "Enter Service Report file no.",
    customerCode: "Customer code",
    pleaseEnterCustomerCode: "Enter customer code",
    customerName: "Customer name",
    pleaseEnterCustomerName: "Enter customer name",
    country: "Country area",
    pleaseEnterCountry: "Enter country area",
    customerAddress: "Customer address",
    pleaseEnterAddress: "Enter customer address",
    customerContact: "Customer contact person",
    pleaseEnterContact: "Enter customer contact person",
    salesRepresentative: "Sales representative",
    pleaseEnterSalesRepresentative: "Please enter sales representative",
    hint: "Notification",
    createDate: "Establish date",
    salesOrderNumber: "Report file No.",
    customerSatisfaction: "Customer satisfaction",
    maintenancePersonnel: "Technician",
    maintenanceTime: "Service time",
    customerConfirmation: "Customer confirm",
    copy: "Copy",
    delete: "Delete",
    recordTime: "Record time",
    machineNumber: "Machine No.",
    copyToSalesOrder: "Copy in",
    copyTo: "Copy to",
    selectSalesOrderNumber: "Select service report file",
    pleaseEnterSalesOrderNumber: "Enter service report file No.",
    latitudeAndLongitude: "Latitude & Longitude",
    startMaintenance: "Start service",
    endMaintenance: "End service",
    newMachine: "Installation",
    maintenance: "Repair",
    addMachineServiceOrder: "Add machine service report file",
    selectType: "Select type",
    generalMaintenance: "Machine repair",
    oilEducationTraining: "OIL training",
    pleaseEnterMachineNumber: "Enter machine No.",
    manufacturingDate: "Manufactued date(Fill within warranty, no need after warranty)",
    pleaseSelectManufacturingDate: "Manufactued date select",
    maintenanceWarranty: "Service in warranty(one year)",
    underWarranty: "Service in warranty period",
    warrantyExpired: "Warranty expired",
    confirm: "OK",
    cancel: "Cancel",
    addMaintenancePersonnel: "Enter add technician name",
    maintenanceTimeTotal: "Total service time",
    day: "Days",
    hour: "Hours",
    enterFactory: "Start service",
    pleaseSelectEnterFactory: "Select start service",
    longitude: "Longitude",
    // pleaseEnterLongitude: "Please enter latitude",
    latitude: "Latitude",
    // pleaseEnterLatitude: "Please enter longitude",
    leaveFactory: "Finish service",
    pleaseSelectLeaveFactory: "Please select finish service",
    duration: "Service time",
    pleaseEnter: "Pleas enter",
    selectTime: "Select date & time select",
    selectSatisfaction: "Customer satisfaction",
    verySatisfied: "Very satisfied",
    satisfied: "Satisfied",
    ordinary: "Ordinary",
    dissatisfied: "Discontent",
    veryDissatisfied: "Very discontent",
    opinionReply: "Customer's comments",
    takePhoto: "Take pictures",
    uploadFile: "Upload file",
    audio: "Audio file",
    video: "Video file",
    electronicSignature: "Customer's signature",
    signatureDate: "Signature date",
    clear: "Delete",
    machineInformation: "Machine Data",
    machineFunction: "Machine Checking",
    organizationArrangement: "Structure & Pattern",
    spareParts: "Parts",
    operationProcedure: "Other records",
    problemHandling: "Process",
    trainee: "Trainee",
    coursePlan: "Course plan",
    courseSchedule: "Course schedule",
    inputVoltageAndCurrent: "Enter voltage/ampere",
    lowSpeed: "Slow speed",
    highSpeed: "High speed",
    accelerationDecelerationSlope: "Acc./Dec. ramp",
    acceleration: "Acc. ramp",
    deceleration: "Dec. ramp",
    clothRoller: "Take up",
    left: "Left",
    center: "Middle",
    right: "Right",
    yarnFeedingTeeth: "Quality gear/pulley",
    saddleRingDistance: "Dial & Cylinder position",
    yarnNozzleNumber: "Yarn carrier position",
    height: "Height",
    spacing: "Gap",
    warpYarnInfo: "Grey fabric",
    inch: "Inches",
    cm: "Centimeters",
    timeSequence: "Timming",
    needle: "Needles",
    yarnSpecification: "Yarn specification",
    yarn: "Yarn",
    serialNumber: "Others machine No.",
    technician: "Technician",
    series: "Fabric series",
    fabricType: "Fabric types",
    productFeatures: "Product features",
    inputVoltage: "Enter voltage",
    inputCurrent: "Enter ampere",
    electronicWindingTensionUpper: "Elec. roller ampere ( upper)",
    electronicWindingTensionLower: "Elec. roller ampere (lower)",
    mechanicalType: "Mech. roller gear",
    lowerNeedleDistanceToSeatRing: "Dis. cylinder & cam holder ring",
    upperNeedleDistanceToSeatRing: "Dis. dial & cam holder ring",
    upperNeedleDistanceToLowerNeedleNozzle: "Gap dial & cylinder knock over edge",
    selectorNeedleRingDistanceToTakeUpPlate: "Dis. between actuator ring & frame",
    seatRingDistanceToTakeUpPlate: "Dis. between cam holder ring & frame",
    machineSpeed: "RPM",
    inverterFrequency: "Inverter HZ",
    yarnCount: "CPI",
    gramsPerSquareMeter: "GSM",
    yardsPerPound: "G/YD",
    customerYarnWidth: "Width",
    customerSpecifiedYarnLength: "Stitch length appoint",
    newCustomerPackageTiming: "Sinker timming",
    doubleSidedCuttingTiming: "Dial cam timming",
    nozzleTiming: "Yarn carrier timming",
    yarnCode: "Yarn code",
    yarnType: "Yarn Spec.",
    color: "Color",
    yarnSize: "Yarn count",
    fiberCount: "Filament",
    innerFiber: "Pile in",
    outerFiber: "Pile out",
    flatness: "Levelness",
    roundness: "Roundness",
    windPressure: "Air pressure",
    appearance: "Appearance",
    machineLevel: "Machine frame levelness",
    trident: "Dial levelness & roundness",
    highLegWinder: "High leg take up",
    fabricSlitting: "Open width take up",
    inverterCurrent: "Inverter ampere",
    machineFunctionFrame: "Yarn MPF & Ring & Creels",
    inchStart: "Jog,start and stop switch func.",
    firstSecondSpeed: "Speed, lamp & fan switch func.",
    firstSecondSpeed2: "Speed setting func.",
    controllerOtherFunctions: "Other func. of controller",
    electricalBoxSignals: "Signals & Sensor",
    fanDustRemovalAction: "Fan operation",
    oilSprayerAction: "Oiler operation",
    airBlowerSystemAction: "Air pressure & operation",
    windingAction: "Take up sys. operation",
    machineControllerOperationTutorial: "Control panel operation training",
    machineOperationTutorial: "M/C operation training",
    other: "Others",
    descriptionAndAttachment: "Reference",
    upperNeedleArrangement: "Dial needles order",
    upperKnifeArrangement: "Dial needles",
    lowerNeedleArrangement: "Cylinder needles order",
    lowerNeedleArrangementShort: 'Cylinder needles',
    lowerKnifeArrangement: "Cylinder knif",
    lowerKnifeArrangementShort: "Cylinder knif",
    upperNeedlePlate: "Dial",
    lowerNeedleCylinder: "Cylinder",
    blank: "Space",
    blockRule: "Measure jigs",
    retractionBaseline: "Sinker dist. back",
    upperPlateNeedleWithdrawalKnob: "Dial scale knob",
    upperPlateNeedleWithdrawalDepth: "Dial stitch dist.",
    upperPlateHalfNeedleHeight: "Dial knit, tuck cam dist.",
    upperPlateFlatNeedleHeight: "Dial miss cam dist.",
    lowerCylinderFlatNeedleHeight: "Cylinder miss cam dist.",
    lowerCylinderFlatNeedleDepth: "Cylinder stitch dist.",
    lowerCylinderNeedleWithdrawalKnob: "Cylinder scale knob",
    yarnTypeCode: "Yarn code",
    yarnTypeTensionN: "Yarn tension (N)",
    cmPer100Needles: "Stitch length /100T",
    feedYarnLengthPerRevolution: "Stitch length/1 Course",
    aluminumPlateYarnFeedingDepthCm: "Quality pulley dia. (cm)",
    yarnFeedingAluminumPlateScale: "Quality pulley mark",
    newCustomerPackage: "Sinker",
    upperPlate: "Dial",
    lowerCylinder: "Cylinder",
    yarnShort: "Yarn",
    pleaseEnterProductName: "Enter parts description",
    pleaseEnterProductNumber: "Enter parts number",
    quantity: "Quantity",
    damage: "Broken",
    missing: "Missing",
    wrong: "Wrong",
    pleaseEnterTitle: "Enter a title",
    pleaseEnterContent: "Enter content",
    addQuestionItem: "Add question item",
    questionProcessingRecord: "Test record",
    pleaseEnterQuestionDescription: "Enter problem description",
    traineeAndClient: "Trainee / Customer",
    trainer: "Trainer",
    drawingFunction: "CAD Function",
    upperMachineProgram: "Machine program",
    UnravelingFunction: "Fabric analysis",
    courseName: "Course name",
    pleaseEnterCourseName: "Enter the course name",
    imageName: "Pattern file name",
    pleaseEnterImageName: "Enter the pattern file name",
    confirmItem: "Confirm",
    undone: "Incomplete",
    pleaseEnterInquire: "Enter Customer Name ,MU document",
    machineUtilizationSurvey: "Machinery utilization",
    customerID: "Customer ID",
    pleaseEnterCustomerID: "Enter customer ID",
    pleaseSelect: "Select",
    pleaseEnterSkill: "Enter skill",
    pleaseEnterBuyer: "Enter buyer",
    pleaseEnterRemark: "Enter remark",
    source: "Source",
    selfInput: "Enter others",
    textileEquipment: "Knitting machine",
    textileMachineBrand: "Knitting machine brand",
    textileMachineType: "Knitting machine model",
    notSelected: "Select not yet",
    select: "Select",
    brand: "Brand",
    totalMachine: "Machine sets",
    openRate: "% of machine utilization",
    dailyOutput: "Production (ton/day)",
    spinning: "Spinning",
    knitting: "Knitting",
    dyeing: "Dyeing",
    garment: "Clothing",
    pleaseEnterProcessingContent: "Please enter the adjustment content.",
    // alert
    editNotSave: "The edits have not been saved. Are you sure to exit?",
    deleteConfirm: "Are you sure to delete?",
    confirmClearSignature: "Are you sure to remove signature-related data?",
    confirmWriteData: "Are you sure to write in the data?",
    confirmCopyToSalesOrder: "Are you sure to copy data to this service report?",
    fieldsNotFilledUnableToSend: "Cannot submit",
    dataWriteComplete: "Data write in complete.",
    deleteSuccess: "Delete successful.",
    clearSuccess: "Remove successful.",
    copySuccess: "Copy successful.",
    selectWorker: 'Please select the maintenance personnel first.',
    selectProblem: 'Please select question item.',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',

    //new
    selectDate: 'Select date',
    yarnTensionN: 'Yarn tension (N)',
    category: 'Type',
    kind: 'Model',
    // pleaseSelectType: '請選擇類型',
    dateInOutError: 'The finish service date must always be equal to or later than the start service date.',
    yarnFeedingTeethOrDisc: 'Quality gear/pulley',
    changed: 'Changed',
    pleaseSelectSparePartsStatus: 'Please select the accessory status.',
    pleaseEnterDuration: 'Please enter service time',

    // API語系
    saveComplete: 'Save successful.',
    needOnline: 'Need Online.',
    addComplete: 'Add successful.',
    reportCreator: 'Report Creator',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: 'Synchronize Fail.',
    synchronizeSuccess: 'Synchronize successful.',
    downloadFail: 'Download Fail.',
    downloadSuccess: 'Download successful.',
    synchronizeSelect: 'Synchronize Select',
    onlySynchronizeOffData: 'Downloading online data',
    synchronizeData: 'Syncing offline data',
    synchronizeImage: 'Synchronize Image',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Download OffLine Data',
    downloadOfflineImage: 'Download OffLine Image',
    synchronizing: 'Synchronizing, please wait. Do not close the app screen.',
    downloading: 'Downloading, please wait. Do not close the app screen.',
    confirmDownload: 'Do you confirm the download?',
    confirmSynchronization: 'Do you confirm the synchronization?',
    overwriteOffline : 'The download will overwrite the current offline data.',
    synchronizationOnline: 'The synchronization will sync the online related data.',
    uploadFail: 'Upload failed.',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Arrange by create order',
    sortByType: 'Arrange by type',
    reportDownload: 'Report',
    selectServiceReport: 'Select Service Report',
    enterServiceReportOrMachine: 'Enter service report no. or machine no.',
    selectAll: 'select all',

    downloadHint:"Background download in progress, please do not click submit repeatedly."
}
